<template>
    <router-link tag="div" to="/Rccl.Review/ReviewPicture/UploadPicture" class="uploadPic js-uploadPicBtn">
        <div class="uploadPic-container">
            <div>
                <img src="../../assets/cameraIcon.png">
            </div>
            <p>上传美照</p>
        </div>
    </router-link>
</template>

<script>
    export default {
        name: 'UploadPic',
        props: {}
    }
</script>

<style lang="less">
    /**** upload pic ****/
    .uploadPic {
        width:108px;
        height:108px;
        position:absolute;
        bottom:0;
        left:50%;
        z-index:11;
        margin-left:-54px;
        background-color:rgba(255,255,255,.5);
        border-radius:54px;
        .uploadPic-container{
            width:100px;
            text-align:center;
            height:100px;
            border-radius:50px;
            margin: 4px auto 0;
            background-color:#061556;
            &>div{
                margin-bottom:5px;
                font-size:0;
                &>img{
                    width:25px;
                    height:20px;
                    margin-top:11px;
                }
            }
            &>p{
                margin:0;
                color:#fff;
                font-size:12px;
            }
        }
        .uploadPic-holdlink {
            width:100%;
            height:100%;
            position:absolute;
            top:0;
            left:0;
        }
    }
</style>
